import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { AuthenticationInstance } from "../utils/authenticationClass";
import { BusinessInstance } from "../utils/businessClass";
import { Dashboard } from "./DashboardPage";

export const HomePage = () => {
  const [src, setSrc] = React.useState<string | null>();
  const dispatch = useDispatch();
  const businesses = useSelector((state: any) => state.business);

  const handleSelectBusiness = async (business: any) => {
    console.log(business);
    await BusinessInstance.setBusiness(business);
  };

  const handleLogout = () => {
    AuthenticationInstance.handleSignOut();
  };

  return (
    <Dashboard>
      <div onClick={handleLogout}>Home page</div>
    </Dashboard>
  );
};
